module.exports = __webpack_public_path__ + "media/reskin-images/icon--calendar-843d6e1a.svg";